import { captureException } from '@sentry/nextjs';
import { Component, ErrorInfo } from 'react';
import P from '../P';
import styles from './index.module.scss';

class ErrorBoundary extends Component<{ href?: string; children?: any }, { hasError: boolean }> {
  constructor(props: { href?: string }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: ErrorInfo) {
    captureException(error);

    console.log({ error, errorInfo });
    // setTimeout(() => {
    //   window.location.href = this.props?.href || '/';
    // }, 2000);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.root}>
          <P useThemeColor styleType={['huge', 'w600']}>
            Oops, there is an error!
          </P>
          <P useThemeColor styleType={['medium', 'w600']}>
            You will be redirected to main page.
          </P>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
